import React from "react";
import Style from "./Transfer.style";
import { Transfer } from "antd";

export default class extends React.Component {

    renderHeader() {
        return (
            <div className="transferHeader">
                <div className="headerEntry bold">{ this.props.header[0] }</div>
                { (this.props.header[1] ) ? <div className="headerEntry bold">{ this.props.header[1] }</div> : null }
            </div>
        );
    }

    render() {
        return (
            <Style>
                {( this.props.header ? this.renderHeader() : null )}
                <Transfer { ...this.props } />
            </Style>
        )
    }

}